import { Stack, Typography } from '@mui/material';
import { isNil } from 'ramda';

import { gridDetailPanelToggleColWidth } from '~/common/constants';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';
import { Multiline } from '~/components/Multiline';

interface RowDetailPanelProps {
  description?: string | null;
}

export const RowDetailPanel = ({ description }: RowDetailPanelProps) => {
  return (
    <Stack
      spacing={4}
      sx={{
        py: 4,
        pr: 4,
        pl: gridDetailPanelToggleColWidth,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        <>{isNil(description) ? NULLISH_CELL_VALUE : <Multiline>{description}</Multiline>}</>
      </Typography>
    </Stack>
  );
};
